import React from 'react';
import { Link } from 'react-router-dom';

import './BlogCategoriesArea.css';

const BlogCategoriesArea = ({ blogPostCategories }) => {
  return (
    <div className='blog-categories-area-container'>
      <h3>Categories</h3>
      <div className='blog-categories-list-container'>
        {blogPostCategories?.map((category, i) => (
          <div key={i}>
            {category.showOnBlogSideBar && (
              <div className='blog-categories-link-container'>
                <Link to={`/blog/category/${category.slug}`}>
                  {category.name}
                </Link>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogCategoriesArea;
